// @flow

import _ from 'lodash';
import ReduceStore from 'PMT/flux/ReduceStore';

import { Events, ActionTypes } from 'constants';

import RoutingEnum from 'constants/RoutingEnum';
import appHistory from "../history"

class RouteStore extends ReduceStore {

  getInitialState() {
    return {
      queryParams: null,
    };
  }

  isEmitingCustomEvents() {
    return true;
  }

  getStateObjectsMap() {
    return {};
  }

  redirectToHome() {
    appHistory.push('/app');
  }

  getPostLoginLocation(): ?Object {
    const state = appHistory.location.state;
    const nextLocation = state && state.nextLocation;
    if (nextLocation
        && typeof nextLocation.pathname === 'string'
        && nextLocation.pathname.startsWith('/')
        && !nextLocation.pathname.startsWith('//')
        && nextLocation.pathname !== RoutingEnum.LOGIN.path
        && nextLocation.pathname !== RoutingEnum.LOGOUT.path) {
      return {
        pathname: nextLocation.pathname,
        search: typeof nextLocation.search === 'string' ? nextLocation.search : '',
        hash: typeof nextLocation.hash === 'string' ? nextLocation.hash : '',
      };
    }
    return null;
  }

  redirectAfterLogin() {
    const nextLocation = this.getPostLoginLocation();
    if (nextLocation) {
      appHistory.replace(nextLocation);
      return;
    }
    this.redirectTo(RoutingEnum.DASHBOARD);
  }

  redirectTo(route, params = null, query = null) {
    let pathname = null;

    if (_.isNull(params)) {
      pathname = route.path;
    } else {
      pathname = route.generatePathWithParams(params);
    }

    // RR4 no longer supports `query: { foo: 1 }`
    // Manually build query string
    let search = '';
    if (!_.isNil(query)) {
      const q = new URLSearchParams(query).toString();
      search = `?${q}`;
    }

    appHistory.push(`${pathname}${search}`);
  }

  getNewQueryParams() {
    return this._state.queryParams;
  }

  reduce(state, action, nextState) {
    switch (action.type) {

      case ActionTypes.REDIRECT:
        this.redirectTo(action.route, action.params, action.query);
        return nextState;

      case ActionTypes.LOGOUT:
        setTimeout(() => {
          this.redirectTo(RoutingEnum.LOGIN);
        }, 2000);
        return nextState;

      case ActionTypes.QUERY_PARAMS_UPDATE:
        nextState.queryParams = action.queryParams;
        this.emitEvent(Events.ON_QUERY_PARAMS_UPDATE);
        return nextState;

      default:
        return nextState;
    }
  }

}

export default new RouteStore();